/**
 * Fictora 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

export const theme = {
  avatarBorder: '#FFFFFF20',
  btnPrimaryBg: '#FFF0F7',
  vipSubscribeBg: 'url(/images/fictora/member_subscribe_bg.webp)',
  subscribeText: '#7D380B',
  subscribeText2: '#AC6D1F',
  subscribeBg: '#90491B',
} as const

export const resources = {
  userBg: '/images/fictora/user-bg.webp',
  userDefaultAvatar: '/images/fictora/user-default.png',
  memberVip: '/images/fictora/vip_icon2.png',
  memberVipDiscount: '/images/fictora/vip_discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
  showLoginBtn: false,
}
